import axios from "axios";
import {useMutation} from "react-query";

//${process.env.REACT_APP_API_URL}/admin/tenants/1630939384?branch=dev6
const updateTenantImage = async (config) => {
    let formData = new FormData();
    formData.append('file', config.homePageConfiguration.logoFormat[0])

    const response = await axios
        .post(
            `${process.env.REACT_APP_API_URL}/admin/tenants/${config.identifier}/documents?branch=${config.branch}`,
            formData
        )
        .catch((err) =>
            console.log("useUpdateTenantImage::updateTenantImage", err)
        );
    return response?.data?.result;
}

export default function useUpdateTenantImage(){
    return useMutation(
        'UPDATE_TENANT_IMAGE',
        (tenantConfig) => {
            return updateTenantImage(tenantConfig)
        }
    );
}
